import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useFetchLeadsCount,
  useFetchUserRanking,
} from "../../tanstack queries/leadsQueries.js";

const AttendeeAbout = ({ singleEvent }) => {
  const navigate = useNavigate();
  const [ranking, setRanking] = useState(null);
  const [leadCount, setLeadCount] = useState({
    hot: 0,
    all: 0,
    warm: 0,
    cold: 0,
  });

  const { data: leadsCountData, error: leadCountError } = useFetchLeadsCount({
    eventId: singleEvent?._id,
  });

  const { data: userRankingData, error: userRankingError } =
    useFetchUserRanking({
      eventId: singleEvent?._id,
    });

  useEffect(() => {
    if (leadsCountData) {
      setLeadCount({ ...leadsCountData?.counts });
    }
    if (leadCountError) {
      console.log(leadCountError);
    }
  }, [leadsCountData, leadCountError, singleEvent?._id]);

  useEffect(() => {
    if (userRankingData) {
      setRanking(userRankingData?.rank);
    }
    if (userRankingError) {
      console.log(userRankingError);
    }
  }, [userRankingData, userRankingError, singleEvent?._id]);

  return (
    <>
      {/* {badegExpand && (
        <AttendeeBadgePopup
          setBadegExpand={setBadegExpand}
          badegExpand={badegExpand}
          savedUserConfig={savedUserConfig}
          singleEvent={singleEvent}
        />
      )} */}

      {/* <AttendeeBadgeModal
        setBadegExpand={setBadegExpand}
        badegExpand={badegExpand}
        savedUserConfig={savedUserConfig}
        singleEvent={singleEvent}
      /> */}
      {singleEvent?._id ? (
        <div className="w-full min-h-[90vh] bg-[#FAFAFA] md:ml-[17%] md:w-[83%] md:bg-white md:min-h-full">
          <div className="w-full h-[60px] fixed top-0 bg-white flex items-center px-[16px] border-b border-[#EDEDED] md:mt-[60px] md:hidden">
            <img
              src="/svgs/Arrowleft.svg"
              className="w-[24px] h-[24px] object-cover cursor-pointer"
              onClick={() => navigate("/events")}
              alt="back"
            />
            <p className="ml-2 text-[22px] font-[500] overflow-hidden overflow-ellipsis whitespace-nowrap w-[95%]">
              {singleEvent?.title}
            </p>
          </div>

          <div className="mt-[55px] mx-[16px] pt-[16px] md:pt-1 md:mt-[70px] pb-[90px] md:ml-[30px]">
            <img
              src={singleEvent?.coverImage}
              alt="coverImage"
              className="h-[194px] w-full rounded-[14px] shadow-[0_0px_8px_1px_rgba(0,0,0,0.1)] md:w-[500px] md:h-[250px] "
            />

            {/* <div
              className="h-[115px] w-full rounded-[10px] mt-4 cursor-pointer md:w-[350px] md:h-[130px] flex flex-col justify-center pl-3 md:pl-3.5 md:mt-[17px] border-[2px] border-[#A55EEA]"
              onClick={() => setBadegExpand(true)}
              style={{
                boxShadow: "0px 0px 14px rgba(165, 94, 234, 0.2)",
              }}
            >
              <div className="mb-1">
                <p className="text-[14px] font-[400] text-[#727374] md:text-[14px]">
                  Tap to expand your badge
                </p>
                <div className="flex mt-[5px] md:mt-[10px] items-center">
                  <img
                    src="/svgs/scanner.svg"
                    alt="Scanner"
                    className="h-[68px] w-[68px] rounded-[4px] md:w-[80px] md:h-[80px] object-contain"
                  />

                  <div className=" flex flex-col ml-3 md:ml-4">
                    <span className="text-[#1C1C1E] font-[500] text-[18px] md:text-[20px]">
                      {savedUserConfig?.firstName} {savedUserConfig?.lastName}
                    </span>
                    <span className="text-[#727374] font-[400] text-[14px] md:text-[14px]">
                      Event badge
                    </span>
                    <span className="text-[#727374] font-[400] text-[13px] md:text-[14px]"></span>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="flex justify-between md:w-[350px] w-full items-center mt-4 md:mt-[30px] gap-4">
              <div className="border w-full  rounded-[10px] py-4 px-5 flex justify-center items-center flex-col gap-1 shadow-[0_0px_8px_1px_rgba(0,0,0,0.1)]">
                <svg viewBox="0 0 24 24" fill="none" width={26}>
                  <g id="SVGRepo_bgCarrier" stroke-width=""></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3 18C3 15.3945 4.66081 13.1768 6.98156 12.348C7.61232 12.1227 8.29183 12 9 12C9.70817 12 10.3877 12.1227 11.0184 12.348C11.3611 12.4703 11.6893 12.623 12 12.8027C12.3107 12.623 12.6389 12.4703 12.9816 12.348C13.6123 12.1227 14.2918 12 15 12C15.7082 12 16.3877 12.1227 17.0184 12.348C19.3392 13.1768 21 15.3945 21 18V21H15.75V19.5H19.5V18C19.5 15.5147 17.4853 13.5 15 13.5C14.4029 13.5 13.833 13.6163 13.3116 13.8275C14.3568 14.9073 15 16.3785 15 18V21H3V18ZM9 11.25C8.31104 11.25 7.66548 11.0642 7.11068 10.74C5.9977 10.0896 5.25 8.88211 5.25 7.5C5.25 5.42893 6.92893 3.75 9 3.75C10.2267 3.75 11.3158 4.33901 12 5.24963C12.6842 4.33901 13.7733 3.75 15 3.75C17.0711 3.75 18.75 5.42893 18.75 7.5C18.75 8.88211 18.0023 10.0896 16.8893 10.74C16.3345 11.0642 15.689 11.25 15 11.25C14.311 11.25 13.6655 11.0642 13.1107 10.74C12.6776 10.4869 12.2999 10.1495 12 9.75036C11.7001 10.1496 11.3224 10.4869 10.8893 10.74C10.3345 11.0642 9.68896 11.25 9 11.25ZM13.5 18V19.5H4.5V18C4.5 15.5147 6.51472 13.5 9 13.5C11.4853 13.5 13.5 15.5147 13.5 18ZM11.25 7.5C11.25 8.74264 10.2426 9.75 9 9.75C7.75736 9.75 6.75 8.74264 6.75 7.5C6.75 6.25736 7.75736 5.25 9 5.25C10.2426 5.25 11.25 6.25736 11.25 7.5ZM15 5.25C13.7574 5.25 12.75 6.25736 12.75 7.5C12.75 8.74264 13.7574 9.75 15 9.75C16.2426 9.75 17.25 8.74264 17.25 7.5C17.25 6.25736 16.2426 5.25 15 5.25Z"
                      fill="#A55EEA"
                    ></path>{" "}
                  </g>
                </svg>
                <p className="font-medium text-gray-500 text-[18px] leading-none mt-1.5">
                  {leadCount?.all || 0}
                </p>
                <p className="font-medium text-[14px] text-gray-500 leading-none mt-0.5">
                  Total Leads
                </p>
              </div>
              <div className="border w-full rounded-[10px] py-4 px-5 flex justify-center items-center flex-col gap-1 shadow-[0_0px_8px_1px_rgba(0,0,0,0.1)]">
                <svg
                  height="26px"
                  width="26px"
                  version="1.1"
                  id="Layer_1"
                  viewBox="0 0 512 512"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      fill="#FF7452"
                      d="M370.809,129.314c-1.881-2.49-5.047-3.645-8.092-2.945c-3.041,0.699-5.389,3.12-5.994,6.181 l-7.04,35.615L262.999,4.216C261.628,1.623,258.934,0,256,0c-0.012,0-0.024,0-0.037,0c-2.947,0.014-5.644,1.664-6.997,4.282 L128.983,236.382l-14.606-46.253c-0.928-2.94-3.478-5.074-6.535-5.468c-3.057-0.397-6.066,1.02-7.711,3.627 c-33.52,53.118-50.515,96.856-50.515,129.996c0,54.487,21.561,104.155,60.713,139.853C148.421,492.871,200.155,512,256,512 s107.579-19.129,145.671-53.862c39.152-35.699,60.713-85.366,60.713-139.853C462.384,273.367,431.574,209.788,370.809,129.314z"
                    ></path>{" "}
                    <path
                      fill="#E24642"
                      // style="fill:#E24642;"
                      d="M302.449,491.942c-55.845,0-107.579-19.129-145.671-53.862 c-39.152-35.699-60.713-85.366-60.713-139.853c0-23.44,8.514-52.188,25.351-85.802l-7.041-22.297 c-0.928-2.94-3.478-5.074-6.535-5.468c-3.057-0.397-6.066,1.02-7.711,3.627c-33.519,53.119-50.514,96.857-50.514,129.997 c0,54.487,21.561,104.155,60.713,139.853C148.421,492.871,200.155,512,256,512c40.953,0,79.686-10.299,112.459-29.484 C347.587,488.715,325.366,491.942,302.449,491.942z"
                    ></path>{" "}
                    <path
                      fill="#FFD652"
                      // style="fill:#FFD652;"
                      d="M125.097,354.177C125.097,281.882,256,134.598,256,134.598s130.903,147.284,130.903,219.579 S328.295,485.08,256,485.08S125.097,426.473,125.097,354.177z"
                    ></path>{" "}
                    <path
                      fill="#FB9D46"
                      // style="fill:#FB9D46;"
                      d="M287.67,453.41c-72.295,0-130.903-58.608-130.903-130.903c0-50.286,63.321-136.836,101.883-184.884 c-1.702-1.958-2.65-3.026-2.65-3.026S125.097,281.882,125.097,354.177S183.705,485.08,256,485.08 c44.235,0,83.341-21.944,107.038-55.536C341.727,444.576,315.731,453.41,287.67,453.41z"
                    ></path>{" "}
                    <g>
                      {" "}
                      <path
                        fill="#E24642"
                        // style="fill:#E24642;"
                        d="M213.773,312.478c-4.373,0-7.918,3.545-7.918,7.918v34.309h-26.392v-34.309 c0-4.373-3.545-7.918-7.918-7.918c-4.373,0-7.918,3.545-7.918,7.918v84.454c0,4.373,3.545,7.918,7.918,7.918 c4.373,0,7.918-3.545,7.918-7.918V370.54h26.392v34.309c0,4.373,3.545,7.918,7.918,7.918c4.373,0,7.918-3.545,7.918-7.918v-84.454 C221.691,316.023,218.146,312.478,213.773,312.478z"
                      ></path>{" "}
                      <path d="M275.002,312.478h-35.893c-4.373,0-7.918,3.545-7.918,7.918v84.454c0,4.373,3.545,7.918,7.918,7.918 h35.893c4.373,0,7.918-3.545,7.918-7.918v-84.454C282.92,316.023,279.375,312.478,275.002,312.478z M267.085,396.932h-20.058 v-68.619h20.058V396.932z"></path>{" "}
                      <path
                        fill="#E24642"
                        // style="fill:#E24642;"
                        d="M340.454,312.478h-42.227c-4.373,0-7.918,3.545-7.918,7.918c0,4.373,3.545,7.918,7.918,7.918h13.196 v76.536c0,4.373,3.545,7.918,7.918,7.918s7.918-3.545,7.918-7.918v-76.536h13.196c4.373,0,7.918-3.545,7.918-7.918 C348.371,316.023,344.826,312.478,340.454,312.478z"
                      ></path>{" "}
                    </g>{" "}
                  </g>
                </svg>

                <p className="font-medium text-gray-500 text-[18px] leading-none mt-1.5">
                  {leadCount?.hot || 0}
                </p>
                <p className="font-medium text-[14px] text-gray-500 leading-none mt-0.5">
                  <span className="text-red-500">Hot</span> Leads
                </p>
              </div>
            </div>

            <div className="my-4 md:w-[350px] w-full">
              <div className="relative overflow-hidden bg-gradient-to-r from-orange-400 to-amber-400 border-none shadow-lg rounded-[14px]">
                <div className="px-4 py-3 text-white">
                  <div className="flex items-center justify-between">
                    {leadCount?.all === 0 ? (
                      <div className="flex items-center gap-2">
                        <div className="bg-white/20 rounded-full min-w-[48px] max-w-[48px] min-h-[48px] max-h-[48px] flex items-center justify-center backdrop-blur-sm">
                          <span className="text-[16px] font-bold text-white">
                            {"#0"}
                          </span>
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-white">
                            Ready, Set, Scan!
                          </h3>
                          <p className="text-white/90 text-sm">
                            You haven't scanned any leads yet — take the first
                            step today!
                          </p>
                        </div>
                      </div>
                    ) : ranking > 1 ? (
                      <div className="flex items-center gap-2">
                        <div className="bg-white/20 rounded-full min-w-[48px] max-w-[48px] min-h-[48px] max-h-[48px] flex items-center justify-center backdrop-blur-sm">
                          <span className="text-[16px] font-bold text-white">
                            {"#"}
                            {ranking}
                          </span>
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-white">
                            Keep Going
                          </h3>
                          <p className="text-white/90 text-sm">
                            You're doing great — capture more leads to climb
                            higher!
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <div className="bg-white/20 rounded-full min-w-[48px] max-w-[48px] min-h-[48px] max-h-[48px] flex items-center justify-center backdrop-blur-sm">
                          <span className="text-[16px] font-bold text-white">
                            {"#"}
                            {ranking}
                          </span>
                        </div>
                        <div>
                          <h3 className="text-lg font-bold text-white">
                            Top Performer
                          </h3>
                          <p className="text-white/90 text-sm">
                            You're capturing more leads than other exhibitors!
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>
              </div>
            </div>

            <div className="mt-3 md:w-[350px] w-full text-center">
              <p className="text-[13px] font-medium text-gray-500">
                How login & use Lead Scanner:{" "}
                <a
                  href="https://u24462104.ct.sendgrid.net/ls/click?upn=u001.wjy3vYYLH-2FCMXPSvc1Yy4Jl5fsBHhnRBHOK-2FeaHcB0oJ6Lm5EQZxBk6itRL8D98YylzRsduu91BKlJ4l22aWPg-3D-3D2pqM_BMjGAqgVkkblrJkIqTdPehE1I5wXvimADYFQZab94zQ-2FwoOht9PZJeTYWEgfgh5gtP982FGkRKSgXoFyGrCMiOQbPdDkhp2KGTUUJUkE9TV0ojRTd56NRSidCsO6XaH0j3cLSKf6Y70tv1ScWOH0y4NJpg68GmXHRrZZpSfr-2BsOenqX7LzqyKte3jFbgZzf9eTAo0fi2BhQiKQ6wvUdz0R58FQeYkfvEJc7BFjY-2FHRxpddbrZWoOagK7Ttq-2BUl9eYDnPkGQ4UERVQzkw-2FXJ5Id9wCecFjcoWWbxzFxqCuGje-2FLulpM91foMzcWYm91071xt-2BCzqDzkiBg5gkfZFYhGizSp13D8C12qxBjjdlczhyIbHzHU4iVhcrypCVKWs35rjSJlWI9Wl65TmXg6czjC8GZ5i4-2F3HXGjc4GgNj8PrVNdMzzR4gwtNaxQmGZnUa2XWcnzgn-2FBADaxaXxQ8ZEAkQ-2F6T86TjWfTHyr14M4NE-3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary underline font-[600]"
                >
                  Watch Video
                </a>
              </p>
            </div>

            <div
              className={`mt-3 h-[45px] w-full md:w-[350px] rounded-[10px] flex justify-center items-center bg-primary cursor-pointer`}
              onClick={() => {
                navigate(
                  `/connections/scan?camera=environment&eventId=${singleEvent?._id}`
                );
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="23"
                fill="#fff"
                viewBox="0 -960 960 960"
                width="23"
              >
                <path d="M109.825-707Q97-707 88.5-715.625T80-737v-113q0-12.75 8.625-21.375T110-880h113q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T223-820h-83v83q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625ZM110-80q-12.75 0-21.375-8.625T80-110v-113q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T140-223v83h83q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5Q253-97 244.375-88.5T223-80H110Zm627 0q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T737-140h83v-83q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T880-223v113q0 12.75-8.625 21.375T850-80H737Zm112.825-627Q837-707 828.5-715.625T820-737v-83h-83q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T737-880h113q12.75 0 21.375 8.625T880-850v113q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625ZM708-251h63v63h-63v-63Zm0-126h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63-63h63v63h-63v-63Zm126-126h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63-63h63v63h-63v-63Zm252-332v252H519v-252h252ZM440-440v252H188v-252h252Zm0-332v252H188v-252h252Zm-50 534v-152H238v152h152Zm0-332v-152H238v152h152Zm331 0v-152H569v152h152Z" />
              </svg>
              <p className="text-white font-[500] text-[14px] ml-1.5">
                Scan Badge
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full min-h-[90vh] bg-[#FAFAFA] md:ml-[17%] md:w-[70%] md:bg-white md:min-h-full px-[16px]">
          <div className="w-full h-[60px] fixed top-0 bg-white flex items-center px-[16px] border-b border-[#EDEDED] md:mt-[60px] md:hidden">
            <img
              src="/svgs/Arrowleft.svg"
              className="w-[24px] h-[24px] object-cover cursor-pointer"
              onClick={() => navigate("/events")}
              alt="back"
            />
            <p className="ml-2 text-[22px] font-[500] overflow-hidden overflow-ellipsis whitespace-nowrap w-[95%]">
              About
            </p>
          </div>
          <div className="bg-[#DDDBDD] mt-[75px] w-full h-[220px] custom-pulse rounded-[8px]"></div>
          <div className="bg-[#DDDBDD] mt-[10px] w-full h-[40px] custom-pulse rounded-[8px]"></div>
          <div className="bg-[#DDDBDD] mt-[10px] w-[70%] h-[40px] custom-pulse rounded-[8px]"></div>
          <div className="bg-[#DDDBDD] mt-[10px] w-full h-[40px] custom-pulse rounded-[8px]"></div>

          <div className="bg-[#DDDBDD] mt-[40px] w-full h-[60px] custom-pulse rounded-[8px]"></div>
          <div className="bg-[#DDDBDD] mt-[20px] w-full h-[160px] custom-pulse rounded-[8px]"></div>
        </div>
      )}
    </>
  );
};

export default AttendeeAbout;
